<template>
  <div class="locale-toggle" role="group" :aria-label="$t('languages.change-language')">
    <button
      v-for="option in options"
      :key="option.locale"
      type="button"
      class="locale-toggle__option"
      :class="{ 'is-active': option.locale === currentLocale }"
      :aria-pressed="String(option.locale === currentLocale)"
      @click="changeLocale(option.locale)"
    >
      {{ option.code }}
    </button>
  </div>
</template>

<script>
import { LOCALE } from '@/util/i18n/locale';
import { getLanguageCode } from '@/util/i18n/get-language-code';

export default {
  name: 'LocaleToggle',
  props: {
    changeLocale: Function,
    currentLocale: String,
  },
  computed: {
    options() {
      return [LOCALE.FR_CA, LOCALE.EN_CA].map((locale) => ({
        locale,
        code: getLanguageCode(locale).toUpperCase(),
      }));
    },
  },
};
</script>

<style lang="scss">
.locale-toggle {
  align-items: center;
  display: inline-flex;
  gap: 2px;

  &__option {
    appearance: none;
    background: transparent;
    border: 0;
    border-radius: $radius-full;
    color: currentColor;
    cursor: pointer;
    font-family: $font-family-body;
    @include text-style('label-md');
    line-height: 1;
    opacity: 0.5;
    padding: 5px 9px;
    position: relative;
    transition: opacity $duration-button $ease-ui-interaction;
    z-index: 0;

    // Soft "thumb" behind the active option, tinted from the inherited text colour
    // so the toggle adapts to both dark panels and light surfaces.
    &::before {
      background: currentColor;
      border-radius: $radius-full;
      bottom: 0;
      content: '';
      left: 0;
      opacity: 0;
      position: absolute;
      right: 0;
      top: 0;
      transition: opacity $duration-button $ease-ui-interaction;
      z-index: -1;
    }

    &:hover {
      opacity: 0.8;
    }

    &:focus-visible {
      opacity: 1;
      outline: 2px solid currentColor;
      outline-offset: 2px;
    }

    &.is-active {
      opacity: 1;

      &::before {
        opacity: 0.16;
      }
    }
  }
}
</style>
